import { createReducer, on } from '@ngrx/store';

import { setDefaultCropYear, setAvailableCropYears } from './app.actions';
import { AppState } from '../shared/models/app.model';

export const initialState = {};

export const appReducer = createReducer<AppState>(
  {},
  on(setDefaultCropYear, (state, { cropYear }) => ({
    ...state,
    defaultCropYear: cropYear,
  })),
  on(setAvailableCropYears, (state, { availableCropYears }) => ({
    ...state,
    availableCropYears,
  })),
);
